export const COMPONENT_NAME = "forgot-email";
